import axios_api from "src/api/axios";
import { prompt } from "src/utils/prompt";

export function useTableRowDelete() {
    return async ({ loadRecords, url,message }) => {
        try {
            const deleteConfirmation = await prompt.confirm(message ? message : "Do you want to delete this record?");
            if (deleteConfirmation.isConfirmed) {
                const { data } = await axios_api.delete(url);
                if(data.result !== "success") {
                    return prompt.error(data["errors"]["instance"]);
                }
                prompt.success("Record has been removed");
                loadRecords();
            }
        } catch (error) {
            prompt.error("Unable to delete record");
        }
    }
}